import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { RESPONSIVE_MEDIA_QUERY_PHONE, RESPONSIVE_MEDIA_QUERY_TABLET, RESPONSIVE_MEDIA_QUERY_DESKTOP } from '../../../responsive';
import { Observer } from '../../patterns/Observer';
var instance;
export var DeviceTypeMediaQuery = /*#__PURE__*/function () {
  function DeviceTypeMediaQuery() {
    var _this = this;
    _classCallCheck(this, DeviceTypeMediaQuery);
    _defineProperty(this, "observer", void 0);
    _defineProperty(this, "lists", {});
    _defineProperty(this, "deviceType", null);
    _defineProperty(this, "subscribe", function (listener) {
      return _this.observer.on(listener);
    });
    this.observer = new Observer();
    this.initDeviceType('phone', RESPONSIVE_MEDIA_QUERY_PHONE);
    this.initDeviceType('tablet', RESPONSIVE_MEDIA_QUERY_TABLET);
    this.initDeviceType('desktop', RESPONSIVE_MEDIA_QUERY_DESKTOP);
  }
  _createClass(DeviceTypeMediaQuery, [{
    key: "getDeviceType",
    value: function getDeviceType() {
      return this.deviceType;
    }
  }, {
    key: "setDeviceType",
    value: function setDeviceType(deviceType) {
      this.deviceType = deviceType;
      this.observer.emit(deviceType);
    }
  }, {
    key: "initDeviceType",
    value: function initDeviceType(deviceType, query) {
      var _this2 = this;
      if (typeof window === 'undefined') {
        return;
      }
      var mql = window.matchMedia(query);
      mql.addListener(function (_ref) {
        var matches = _ref.matches;
        if (matches) {
          _this2.setDeviceType(deviceType);
        }
      });
      if (mql.matches) {
        this.deviceType = deviceType;
      }
      this.lists[deviceType] = mql;
    }
  }], [{
    key: "ensureSingleton",
    value: function ensureSingleton() {
      if (!instance) {
        instance = new DeviceTypeMediaQuery();
      }
      return instance;
    }
  }]);
  return DeviceTypeMediaQuery;
}();